import { createContext } from "react";

/**
 * Kontekst zalogowanego użytkownika
 */
const UserContext = createContext({
  user: {
    id: "",
    firstName: "",
    lastName: "",
    currentStep: null,
    permissions: [],
    roles: [],
    isSurveyActive: null,
    surveyValidationDate: null,
    isFirstRecrutation: "",
    isSecondOrderAvailable: false,
    hasSpecialContract: false,
    contractRecruitmentTypes: { "1": "standard", "2": "standard" },
    clientStep: null,
    recruitmentType: "standard",
    fromReserveList: false,
    consentToVouchers: false,
  },
  setUser: () => {},
  isLoading: true,
  setIsLoading: () => {},
});

export default UserContext;
